import { Box, Typography } from '@mui/material';

const Palettes = () => {
  const colors = [
    'primary',
    'secondary',
    'success',
    'info',
    'warning',
    'error',
  ];

  const tertiary = [
    'orange',
    'yellow',
    'yellowGreen',
    'skyBlue',
    'purplishBlue',
    'purplishRed',
    'grey',
  ];

  return (
    <Box>
      <Typography variant="h3">Color Palette</Typography>
      <Box display={'flex'} gap={2} flexWrap={'wrap'} mt={2}>
        {colors.map((color, index) => (
          <Box key={index} width={1} maxWidth={250}>
            <Typography variant="subtitle2" mb={1}>
              {color.toUpperCase()} Color
            </Typography>
            <Box bgcolor={`${color}.lighter`} width={1} height={25} />
            <Box bgcolor={`${color}.light`} width={1} height={25} />
            <Box bgcolor={`${color}.main`} width={1} height={25} />
            <Box bgcolor={`${color}.dark`} width={1} height={25} />
            <Box bgcolor={`${color}.darker`} width={1} height={25} />
          </Box>
        ))}
      </Box>
      <Box display={'flex'} gap={2} flexWrap={'wrap'} mt={2}>
        {tertiary.map((color, index) => (
          <Box key={index} width={1} maxWidth={250}>
            <Typography variant="subtitle2" mb={1}>
              {color.toUpperCase()} Color
            </Typography>
            <Box bgcolor={`${color}.50`} width={1} height={25} />
            <Box bgcolor={`${color}.100`} width={1} height={25} />
            <Box bgcolor={`${color}.200`} width={1} height={25} />
            <Box bgcolor={`${color}.300`} width={1} height={25} />
            <Box bgcolor={`${color}.500`} width={1} height={25} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Palettes;
